// src/components/MainLayout.jsx
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const MainLayout = () => (
  <div id="main-wrapper">
    <Header />
    <main id="content">
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default MainLayout;
